import React from 'lib/react';
import {
  EVGrid,
  EVAlert,
  EVTypography,
  EVButton,
} from 'lib/components';
import PropTypes from 'prop-types';

import ValidationMessageBannerStyles from './ValidationMessageBannerStyles';

export default function ValidationMessageBanner({ title, heading, elementRefInfo }) {
  if (elementRefInfo == null || Object.keys(elementRefInfo).length === 0) return null;
  const classes = ValidationMessageBannerStyles();

  return (
    <EVAlert severity="error" className={classes.alert}>
      <EVGrid container className={classes.mainContainer} direction="column">
        <EVTypography className={classes.title}>{title}</EVTypography>
        {heading !== null && <EVTypography className={classes.errorHeading}>{heading}</EVTypography>}
        <EVGrid container item direction="column" className={classes.errorContainer}>
          <ul>
            {Object.entries(elementRefInfo).filter(([, validationInfo]) => validationInfo.message != null
            && validationInfo.message.length > 0).map(([key, validationInfo]) => (
              <li key={`validation-for-${key}`}>
                <EVButton
                  type="button"
                  id={`validation-for-${key}`}
                  onClick={() => validationInfo.elementRef?.current?.focus()}
                  className={classes.button}
                  disableRipple
                >
                  <EVTypography className={classes.message}>{validationInfo.message}</EVTypography>
                </EVButton>
              </li>
            ))}
          </ul>
        </EVGrid>
      </EVGrid>
    </EVAlert>
  );
}

ValidationMessageBanner.propTypes = {
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
  elementRefInfo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    elementRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    message: PropTypes.string.isRequired,
  }).isRequired,
};

ValidationMessageBanner.defaultProps = {
  heading: null,
};
